export const shortenName = (name, nameLength) => {
    const newName = name?.length > nameLength ? `${name.substring(0, nameLength)}...»` : name
    return newName
}